var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayMaestroLogo = function SvgPayMaestroLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M26.876 11.7H15.23v21.6h11.646z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M15.738 22.502a14.15 14.15 0 0 1 1.28-5.904 13.4 13.4 0 0 1 3.586-4.712 12.35 12.35 0 0 0-6.512-2.81c-2.38-.269-4.787.176-6.924 1.28a13.03 13.03 0 0 0-5.227 4.982A14.1 14.1 0 0 0 0 22.5c0 2.533.673 5.014 1.94 7.162a13.03 13.03 0 0 0 5.228 4.981 12.1 12.1 0 0 0 6.924 1.28 12.35 12.35 0 0 0 6.512-2.807 13.4 13.4 0 0 1-3.587-4.712 14.16 14.16 0 0 1-1.279-5.902"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M42.106 22.502c0 2.532-.703 5.014-2.027 7.161a13.36 13.36 0 0 1-5.455 4.98 13.1 13.1 0 0 1-7.224 1.28 13.17 13.17 0 0 1-6.794-2.81 13.5 13.5 0 0 0 3.74-4.712 13.7 13.7 0 0 0 1.337-5.901 13.7 13.7 0 0 0-1.337-5.901 13.5 13.5 0 0 0-3.74-4.711 13.105 13.105 0 0 1 14.017-1.531 13.36 13.36 0 0 1 5.458 4.978 13.66 13.66 0 0 1 2.024 7.163z"
  })));
};
export default SvgPayMaestroLogo;